import { createReducer, on } from '@ngrx/store';
import { UploadedDriverLicense } from '../../../../models/document.model';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlUploadBackendState {
    doc: UploadedDriverLicense | null;
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlUploadBackendState = { doc: null, state: 'pending' };

export const dlUploadBackendReducer = createReducer(
    initialState,
    on(driverLicenseActions.uploadBackend, (state) => ({ ...state, doc: null, state: 'loading' as const })),
    on(driverLicenseActions.uploadBackendSuccess, (state, { payload }) => ({ ...state, doc: payload, state: 'loaded' as const })),
    on(driverLicenseActions.uploadBackendFail, (state) => ({ ...state, doc: null, state: 'error' as const })),
    on(driverLicenseActions.clearUploadBackend, () => initialState)
);
